import chevironRight from "$/cheviron-right.svg";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { LayoutHeader } from "@/Header";
import {
  useBusinessAnnouncementList,
  type AnnouncementListItem,
} from "~/services/business/announcement";

export const Route = createFileRoute(
  "/business/layout/user-owner-announcement"
)({
  component: BusinessAnnouncementList,
});

const CATEGORY_LABEL: Record<AnnouncementListItem["category"], string> = {
  SYSTEM: "업데이트",
  MAINTENANCE: "점검",
  EVENT: "이벤트",
  GENERAL: "공지",
};

const CATEGORY_TONE: Record<
  AnnouncementListItem["category"],
  { bg: string; text: string }
> = {
  SYSTEM: { bg: "bg-[#DBEAFE]", text: "text-[#1D4ED8]" },
  MAINTENANCE: { bg: "bg-amber-100", text: "text-amber-700" },
  EVENT: { bg: "bg-green-100", text: "text-green-700" },
  GENERAL: { bg: "bg-[#F3F4F6]", text: "text-[#374151]" },
};

function BusinessAnnouncementList() {
  const { history } = useRouter();
  const { data: list, isLoading } = useBusinessAnnouncementList();

  return (
    <>
      <LayoutHeader title={"공지사항"} hasBackBtn hasFootPrint={false} />
      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col bg-[#F5F5F5] min-w-0 w-full overflow-x-hidden px-3 pt-4">
        {isLoading ? (
          <div className="flex items-center justify-center h-40 text-sm text-[#666666]">
            로딩 중...
          </div>
        ) : !list || list.length === 0 ? (
          <div className="flex items-center justify-center h-40 text-sm text-[#666666]">
            등록된 공지사항이 없습니다.
          </div>
        ) : (
          <div className="bg-white border-2 border-[#E9E9E9] rounded-xl divide-y divide-[#F0F0F0] overflow-hidden">
            {list.map((item) => {
              const tone = CATEGORY_TONE[item.category];
              return (
                <button
                  key={item.id}
                  className={`flex justify-between items-center gap-2 px-4 py-3 w-full max-w-full min-w-0 text-left ${
                    item.isPinned ? "bg-[#FFF8EE]" : ""
                  }`}
                  onClick={() =>
                    history.push(
                      `/business/layout/user-owner-announcement-detail?id=${item.id}`
                    )
                  }
                >
                  <div className="flex flex-col flex-1 min-w-0 w-full">
                    <div className="flex items-center gap-1.5 min-w-0">
                      {!item.isRead && (
                        <span
                          aria-label="안읽음"
                          className="flex-shrink-0 w-2 h-2 rounded-full bg-[#EF4444]"
                        />
                      )}
                      {item.isPinned && (
                        <span className="flex-shrink-0 inline-flex items-center rounded bg-orange-100 px-1.5 py-0.5 text-[10px] font-semibold text-orange-600">
                          고정
                        </span>
                      )}
                      {item.isImportant && (
                        <span className="flex-shrink-0 inline-flex items-center rounded bg-[#FEE2E2] px-1.5 py-0.5 text-[10px] font-semibold text-[#DC2626]">
                          중요
                        </span>
                      )}
                      <span
                        className={`flex-shrink-0 inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-semibold ${tone.bg} ${tone.text}`}
                      >
                        {CATEGORY_LABEL[item.category]}
                      </span>
                      <span
                        className={`flex-1 min-w-0 block truncate text-[15px] ${
                          item.isImportant
                            ? "font-bold text-[#222222]"
                            : item.isRead
                              ? "font-medium text-[#666666]"
                              : "font-medium"
                        }`}
                      >
                        {item.title}
                      </span>
                    </div>
                    <span className="text-xs text-[#999999] mt-1">
                      {item.createdAt}
                    </span>
                  </div>
                  <img
                    src={chevironRight}
                    alt="상세보기"
                    className="flex-shrink-0 w-4 h-4"
                  />
                </button>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
